export const NO_VALUES_AVAILABLE_LABEL = 'No values available'
export const CLEAR_ALL_LABEL = 'Clear all'
export const SEARCH_PLACEHOLDER = 'Search'
